<template>
    <div>
        <button type="button" class="btn btn-outline-success btn-sm btn-excel font-weight-bold" style="width: 100%" @click="pegaConsolidado()"> 
            <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            Consolidado
        </button>

        <table id="table-consolidado-export" style="display: none;" v-if="consolidado.length > 0">
            <tr>
                <td style="font-weight: bold; text-align:center;" colspan="3">CONSOLIDADO DE ENFERMARIAS EM {{date}}</td>
            </tr>
            <tr>
                <td style="font-weight: bold; text-align:center;" colspan="3">{{unidade.cnes}} - {{unidade.nome}}</td>
            </tr>
            <tr style="background-color: #006e95; color: white; text-align:center;">
                <td>ENFERMARIA</td>
                <td>NOME</td> 
                <td>QUANTIDADE DE LEITOS</td>
            </tr>
            <tr v-for="(item, index) in consolidado" :key="index">
                <td style="text-align: center;">{{item.codigoEnfermaria}}</td>
                <td style="text-align: center;">{{item.nomeEnfermaria}}</td>
                <td style="text-align: center;">{{item.quantidade}}</td>
            </tr>

        </table>
    </div>
</template>

<script>
export default {
    props: {
        unidade: {
            type: Object
        }
    },
    computed: {
        date () {
            let dia = new Date().getDate()
            let mes = new Date().getMonth() + 1
            let ano = new Date().getFullYear()
            let hora = new Date().getHours()
            let minutos = new Date().getMinutes()

            if (dia.toString().length == 1) dia = '0' + dia;
            if (mes.toString().length == 1) mes = '0' + mes;
            if (minutos.toString().length == 1) minutos = '0' + minutos;
            if (hora.toString().length == 1) hora = '0' + hora;

            return `${dia}/${mes}/${ano} ${hora}:${minutos}`
        },
        consolidado () {
            return this.$store.getters['consultas/getConsolidado']
        }
    },
    methods: {
        pegaConsolidado () {
            this.$store.dispatch('consultas/buscaConsolidado', this.unidade.cnes).then(() => {
                setTimeout(() => this.tablegenerator(), 300)
            })
        },
        tablegenerator () {
            let filename = 'Consolidado' + '.xls'
            this.exportExcel('Consolidado', filename)
        },
        exportExcel (name, filename) {

        let uri = 'data:application/vnd.ms-excel;base64,',
                template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><title></title><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'

        let base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
        let format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; })}

        let table = document.getElementById("table-consolidado-export")
        let inner = table.innerHTML

        var ctx = {worksheet: name || 'Worksheet', table: inner}


        var link = document.createElement('a')
        link.download = filename
        link.href = uri + base64(format(template, ctx))
        link.click()

        }
    }
}
</script>

<style>
#table-export td {
    border: 1px solid black;
}
</style>
